module.exports = __webpack_public_path__ + "img/h.4cded060.jpg";